import { DefaultSizeConstraints } from './../size';

export const noLocation = {
  location: null,
  sizeConstraints: DefaultSizeConstraints,
};
